import React, { useContext, useEffect, useState } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import { Autocomplete, Button, Checkbox, Container, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import RtlProvider from '../../../Components/RtlProvider';
import { ContextNotification, severitys } from '../../../App';
import helper from '../../../helper';
import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import hotelApi from '../../../api/hotelApi';
import cityApi from '../../../api/cityApi';
import companyApi from '../../../api/companyApi';

import { RHFAutocompleteMultiple } from '../../../Components/RHFAutocompleteMultiple';
import staticVariablesApi from '../../../api/staticVariablesApi';
import BeatLoading from '../../../Components/Loader/BeatLoader';
const EditHotel = () => {
  const { open, setOpen } = useContext(ContextNotification);
  const navigate = useNavigate();
  const [Cities, SetCities] = useState([]);
  const [Regions, SetRegions] = useState([]);
  const [Companies, SetCompanies] = useState([])
  const [PriceGroups, SetPriceGroups] = useState([])
  const [DefaultCompanies, setDefaultCompanies] = useState(null)
  const [submitLoading, setSubmitLoading] = useState(false);
  const { id } = useParams();
  const schema = yup.object().shape({
    name: yup.string().required("نام هتل را وارد نمایید"),
    cityConsistency: yup.string().required("شهر را انتخاب نمایید"),
    region: yup.string().required("منطقه را انتخاب نمایید"),
    priceGroup: yup.string().required("گروه قیمتی الزامی است")
  });
  const { register, handleSubmit, formState: { errors }, control } = useForm({
    defaultValues: async () => {
      return hotelApi.GetByKey(id)
        .then(res => {
          const arr = res.data.data.company.map((item) => {
            return {
              label: item.name,
              id: item.code
            };
          });

          setDefaultCompanies(arr);
          return {
            name: res.data.data.name,
            isActive: res.data.data.isActive,
            address: res.data.data.address,
            cityConsistency: res.data.data.cityConsistency.toString(),
            description: res.data.data.description,
            region: res.data.data.region.toString(),
            managerName: res.data.data.managerName,
            managerPhoneNumber: res.data.data.managerPhoneNumber,
            //companyCode: arr,
            priceGroup: res.data.data.priceGroup.toString(),
            arabianAddress: res.data.data.arabianAddress,
            phoneNumber: res.data.data.phoneNumber,
          }
        })
        .catch(err => console.log(err));

    },
    resolver: yupResolver(schema),
  });
  const onSubmit = (data) => {
    setSubmitLoading(true);
    // let companyCodeList = [];
    var dict = {};
    for (let index = 0; index < data.companyCode?.length; index++) {
      const element = data.companyCode[index];
      dict[element.id] = element.label;
      // companyCodeList.push(parseInt(element.id))
    }
    const newData = {
      "id": id,
      "name": data.name,
      "address": data.address,
      "arabianAddress": data.arabianAddress,
      "cityConsistency": parseInt(data.cityConsistency),
      "description": data.description,
      "companyInfo": dict,
      "priceGroup": parseInt(data.priceGroup),
      "region": parseInt(data.region),
      "isActive": data.isActive,
      "managerName": data.managerName,
      "managerPhoneNumber": data.managerPhoneNumber,
      "phoneNumber": data.phoneNumber
    }
    hotelApi.Update(newData).then((res) => {
      if (res.data.success) {
        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
        navigate("/dashboard/HotelPanel");
      }
      else {
        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
      }
    }).catch(err => {
      if (err.response) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
      }
    }
    ).finally(() => { setSubmitLoading(false); });
  };

  useEffect(() => {
    GetCityDropDown();
    GetRegionDropDown();
    GetCompanyDropDown();
    GetPriceGroupDropDown();
  }, []);

  const GetRegionDropDown = () => {
    staticVariablesApi.GetRegionDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data);
        SetRegions(arr.map((item) => {
          return {
            id: item.key,
            label: item.value
          };
        }))
      })
      .catch((error) => console.log(error));
  };

  const GetCityDropDown = () => {
    staticVariablesApi.GetArabicCityConsistencyDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        const mappedReponse = arr.map((r) => {
          return {
            id: r.key,
            label: r.value
          };
        });
        SetCities(mappedReponse);
      })
      .catch((error) => console.log(error));
  };

  const GetCompanyDropDown = () => {
    companyApi.CompanyCodeDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data);
        SetCompanies(arr.map((item) => {
          return {
            id: item.key,
            label: item.value
          };
        }))
      })
      .catch((error) => console.log(error));
  };
  const GetPriceGroupDropDown = () => {
    staticVariablesApi.GetPriceGroupDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data);
        SetPriceGroups(arr.map((item) => {
          return {
            id: item.key,
            label: item.value
          };
        }))
      })
      .catch((error) => console.log(error));
  }
  const handleRegionChanged = (id) => { };
  const handleCityChanged = (id) => { };
  const handleCompanyChanged = (id) => { };
  const handlePriceGroupChanged = (id) => { }

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
      >
        <Button variant="contained"
          component={NavLink} to={`/dashboard/HotelPanel`} color="primary" style={{ marginBottom: 10 }}>بازگشت</Button>
      </Grid>
      <Container component="main" maxWidth="xs">
        <form onSubmit={handleSubmit(onSubmit)}>
          <RtlProvider>
            <Typography component="h1" variant="h5" mb={2}>
              ویرایش هتل
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField id="outlined-basic" variant="outlined" {...register("name")} fullWidth label="نام" InputLabelProps={{ shrink: true }} error={!!errors?.name}
                  helperText={errors?.name?.message} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField id="outlined-basic" variant="outlined" {...register("phoneNumber")} fullWidth label="تلفن هتل" InputLabelProps={{ shrink: true }} error={!!errors?.phoneNumber}
                  helperText={errors?.phoneNumber?.message} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField id="outlined-basic" variant="outlined" {...register("managerName")} fullWidth label="نام مدیر" InputLabelProps={{ shrink: true }} error={!!errors?.managerName}
                  helperText={errors?.managerName?.message} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField id="outlined-basic" variant="outlined" {...register("managerPhoneNumber")} fullWidth label="تلفن مدیر هتل" InputLabelProps={{ shrink: true }} error={!!errors?.managerPhoneNumber}
                  helperText={errors?.managerPhoneNumber?.message} />
              </Grid>
              <Grid item xs={12}>
                <TextField multiline id="outlined-basic" variant="outlined" {...register("address")} fullWidth label="آدرس فارسی" InputLabelProps={{ shrink: true }} error={!!errors?.address}
                  helperText={errors?.address?.message} />
              </Grid>
              <Grid item xs={12}>
                <TextField multiline id="outlined-basic" variant="outlined" {...register("arabianAddress")} fullWidth label="آدرس عربی" InputLabelProps={{ shrink: true }} error={!!errors?.arabianAddress}
                  helperText={errors?.arabianAddress?.message} />
              </Grid>
              <Grid item xs={12}>
                <TextField multiline id="outlined-basic" variant="outlined" {...register("description")} fullWidth label="توضیحات" InputLabelProps={{ shrink: true }} error={!!errors?.description}
                  helperText={errors?.description?.message} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <RHFAutocomplete
                  control={control}
                  options={Regions ?? []}
                  name="region"
                  placeholder="منطقه"
                  onChange={handleRegionChanged}
                  style={{
                    border: "none",
                    padding: 0
                  }}
                  error={!!errors?.region}
                  helperText={errors?.region?.message}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <RHFAutocomplete
                  control={control}
                  options={Cities ?? []}
                  name="cityConsistency"
                  placeholder="شهر"
                  onChange={handleCityChanged}
                  style={{
                    border: "none",
                    padding: 0
                  }}
                  error={!!errors?.cityConsistency}
                  helperText={errors?.cityConsistency?.message}
                />
              </Grid>
              <Grid item xs={12}>
                {/* <RHFAutocompleteMultiple
              
              control={control}
              options={Companies ?? []}
              name="CompanyId"
              placeholder="شرکت عربی"
              onChange={handleCompanyChanged}
              style={{
                border: "none",
                padding: 0
              }}
              
            /> */}
                {Companies.length > 0 && DefaultCompanies && <Controller
                  control={control}
                  name="companyCode"
                  defaultValue={DefaultCompanies}
                  render={({ field: { ref, onChange, ...field } }) => (
                    <Autocomplete
                      multiple
                      options={Companies}
                      getOptionLabel={(option) => option.label}
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                      onChange={(_, data) => {
                        onChange(data)
                      }}
                      defaultValue={DefaultCompanies}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          {...field}
                          fullWidth
                          inputRef={ref}
                          label="شرکت عربی"
                        />
                      )}
                    />
                  )}
                />
                }

              </Grid>
              <Grid item xs={12} sm={8}>
                <RHFAutocomplete
                  control={control}
                  options={PriceGroups ?? []}
                  name="priceGroup"
                  placeholder="گروه قیمتی"
                  onChange={handlePriceGroupChanged}
                  style={{
                    border: "none",
                    padding: 0
                  }}
                  error={!!errors?.priceGroup}
                  helperText={errors?.priceGroup?.message}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControlLabel
                  control={
                    <Controller
                      name="isActive"
                      control={control}
                      defaultValue={false}
                      render={({ field: { value, ref, ...field } }) => (
                        <Checkbox
                          {...field}
                          inputRef={ref}
                          checked={!!value}
                          color="primary"
                          size={"medium"}
                          disableRipple
                        />
                      )}
                    />
                  }
                  label="فعال"
                  labelPlacement="end"
                />
              </Grid>
              <Grid item xs={12}>
                <Button type="submit" variant="contained" color="secondary" disabled={submitLoading}><BeatLoading loading={submitLoading} color={"#e65100"} size={8} />ویرایش</Button>
              </Grid>
            </Grid>
          </RtlProvider>
        </form>
      </Container>
    </>
  )
}
export default EditHotel;